<style lang="scss" scoped>
.class {
    & ::v-deep .el-select {
        width: 100%;
    }
    &__container {
        @include container;
    }
    &__panel {
        @include main-panel;
    }
    &__header {
        display: flex;
        justify-content: space-between;
        @include flex-center;
        &__options {
            margin-left: auto;
        }
    }
    &__footer {
        @include main-panel-footer;
        &__right {
            margin-left: auto;
        }
    }
    &__warning {
        color: red;
        font-size: 20px;
        padding-top: 7px;
    }
    &__details {
        &__container {
            padding-left: 1.5rem;
            padding-right: 1.5rem;
            margin-bottom: 1.5rem;
        }
        &__body {
            border-radius: 0.375rem;
            padding-right: 1.5rem;
        }
        &__icon {
            padding: 20px;
            border-radius: 20px 0px;
            display: inline-block;
            font-size: 30px;
            margin: 50px 0 10px;
            background-color: #ee5918;
            color: #fff;
        }
        &__table {
            font-size: 12px;
            color: #292827;
            border-spacing: 18px;
        }

        &__table-val {
            border: 1px solid #8a8886;
            padding: 5px 100px 5px 5px;
            margin-bottom: 3px;
            background-color: #e6e6e6;
        }
    }
}
</style>
<template lang="pug">
.class__details__container
    .class__details__icon
        div {{ selectedClass.name }}
    .class__details__body
        table.class__details__table
            thead
                tr
                    th(width="150")
            tbody
                tr
                    td Name
                    td.class__details__table-val {{ selectedClass.name }}
                tr
                    td Email
                    td.class__details__table-val {{ selectedClass.emailAddress }}
                tr
                    td Object Id
                    td.class__details__table-val {{ selectedClass.id }}
                tr(v-if="owner.length")
                    td Owner{{ owner.length > 1 ? 's': '' }}
                    td.class__details__table-val  {{ owner ? owner.join(", ") : 'N/A' }}
</template>

<script>
export default {
    props: {
        selectedClass: Object,
        owner: Array,
    }
}
</script>